export default __webpack_public_path__ + "static/media/Ambience One.eaeb1b4c.mp3";